import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Carousel } from 'primeng/carousel';
import { ProductService } from 'src/services/productservice';

@Component({
  selector: 'app-island-groups',
  templateUrl: './island-groups.component.html',
  styleUrls: ['./island-groups.component.scss'],
})
export class IslandGroupsComponent implements OnInit {
  responsiveOptions: { breakpoint: string; numVisible: number; numScroll: number }[];
  islandsBannerAndContent: any = { bannerImage: null, bannerTitle: null, content: null };
  id: any;
  islandsGroups: any;
  islandTitle: any;
  language: string;
  images: any = [];
  activeIndex: any;
  displayCustom: boolean;

  constructor(private route: ActivatedRoute, private router: Router, private productService: ProductService) {}

  ngOnInit(): void {
    this.language = localStorage.getItem('language');
    Carousel.prototype.onTouchMove = () => {};

    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
    this.route.queryParams.subscribe((params) => {
      this.id = params['id'];
      // this.islandType = params['islandType'];
      this.getDetails();
      this.getIslandGroups();
    });
    this.getDetails();
  }
  islandsDetails(item: any) {
    var queryParams = this.productService.getBlogViewNode(item);
    this.router.navigate(['/island-details'], {
      queryParams: { view_node: queryParams },
    });
  }
  getDetails() {
    this.productService.getouterIslandsBannerAndContent().then((innerIslands) => {
      if (innerIslands) {
        this.islandsBannerAndContent = innerIslands;
        this.images.push(this.islandsBannerAndContent.bannerImage);
      }
    });
  }
  getIslandGroups() {
    this.productService.getIslandGroupDetails(this.id).then((islandGroups) => {
      if (islandGroups) {
        this.islandsGroups = islandGroups;
        this.islandTitle = islandGroups[0].field_island_grouping
          ? islandGroups[0].field_island_grouping
          : 'Island Groups';
      }
    });
  }
  islandsAllGroups() {
    this.router.navigate(['/islands-all'], {
      queryParams: { islandsGroupId: this.id, islandType: 'outerIslands' },
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
